/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stop_Call_SkippedInputs */

const fr_stop_call_skipped = /** @type {(inputs: Stop_Call_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêt non desservi`)
};

const en_stop_call_skipped = /** @type {(inputs: Stop_Call_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop not served`)
};

/**
* | output |
* | --- |
* | "Stop not served" |
*
* @param {Stop_Call_SkippedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const stop_call_skipped = /** @type {((inputs?: Stop_Call_SkippedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_Call_SkippedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stop_call_skipped(inputs)
	return en_stop_call_skipped(inputs)
});